
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { useLanguage } from '@/components/i18n/language-provider';
import FadeInSection from '@/components/ui/FadeInSection';

const IntroSection: React.FC = () => {
  const { t } = useLanguage();

  return (
    <>
      <FadeInSection>
        <h1 className="text-4xl md:text-5xl font-extrabold text-center mb-8">
          {t('Compare Keystle vs. Auth0 & Keycloak')}
        </h1>
        
        <p className="text-lg text-muted-foreground text-center mb-12 max-w-4xl mx-auto">
          {t("Selecting the ideal Identity and Access Management solution requires balancing security, flexibility, user experience, and cost-effectiveness. Discover why organizations are increasingly choosing Keystle for their authentication needs.")}
        </p>
      </FadeInSection>

      <FadeInSection delay={100}>
        <Card className="mb-12 bg-primary/5 border-primary/20">
          <CardContent className="pt-6">
            <h2 className="text-2xl font-bold mb-4 flex items-center">
              {t('Keystle: Enterprise Security with Modern Experience')}
            </h2>
            <p className="text-muted-foreground">
              {t("Keystle delivers a passwordless-first IAM platform complete with adaptive MFA, robust multi-tenant architecture, and intelligent behavior analysis built-in. Engineered for both enterprise environments and growing SaaS platforms, Keystle streamlines access management, enhances security posture, and ensures compliance while delivering a seamless user experience.")}
            </p>
          </CardContent>
        </Card>
      </FadeInSection>
    </>
  );
};

export default IntroSection;
